var _defs, _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Guides",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#f9a51a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "_Path_",
    "data-name": "<Path>",
    className: "cls-1",
    cx: 60,
    cy: 60,
    r: 60
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M736.95,1723.95a1.75,1.75,0,0,1,1.73,1.73v35.41a1.75,1.75,0,0,1-1.73,1.73H706a1.75,1.75,0,0,1-1.73-1.73v-35.41a1.75,1.75,0,0,1,1.73-1.73h10.6a4.91,4.91,0,0,0,9.78,0h10.6m-15.49-7.13a6.66,6.66,0,0,0-6.24,4.43H706a4.44,4.44,0,0,0-4.43,4.43v35.41a4.44,4.44,0,0,0,4.43,4.43h31a4.44,4.44,0,0,0,4.43-4.43v-35.41a4.44,4.44,0,0,0-4.43-4.43H727.7a6.66,6.66,0,0,0-6.24-4.43h0Zm0,8.85a2.21,2.21,0,1,1,2.21-2.21,2.22,2.22,0,0,1-2.21,2.21h0Z",
    transform: "translate(-661.46 -1681.17)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M710.39,1732.31h22.13v-11.06H727.7a6.61,6.61,0,0,0-12.48,0h-4.82v11.06Zm11.06-11.06a2.21,2.21,0,1,1-2.21,2.21A2.22,2.22,0,0,1,721.46,1721.25Z",
    transform: "translate(-661.46 -1681.17)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.dc6009e692574870f39c7a5ef8306004.svg";
export { ForwardRef as ReactComponent };